import { defineMeta } from '@/registry/types';

export const filterPopoverMeta = defineMeta({
  name: 'FilterPopover',
  level: 'organism',
  category: 'input',
  classification: 'custom',
  description:
    'Popover-triggered filter editor built from a filters config. Supports per-filter search, select-all, single/multi selection, apply/reset, loading, async hooks and localStorage persistence.',
  baseLibrary: 'custom',
  muiEquivalent: 'Popover (composed)',
  a2uiEquivalent: 'FilterPopover',
  importPath: '@/organisms/FilterPopover',
  requiredProps: ['filters'],
  optionalProps: [
    'value',
    'defaultValue',
    'onApply',
    'onReset',
    'loading',
    'searchable',
    'showSelectAll',
    'persistKey',
    'triggerLabel',
    'async',
  ],
  props: [
    { name: 'filters', type: 'FilterDef[]', required: true, description: 'Filter definitions with options' },
    { name: 'value', type: 'Record<string, { operator, values }>', description: 'Controlled selection' },
    { name: 'persistKey', type: 'string', description: 'localStorage key to persist the applied selection' },
  ],
  supportedStates: ['default', 'open', 'loading', 'has-active-filters'],
  designTokens: ['colors', 'radius', 'spacing'],
  accessibility: [
    'Trigger is a real button; options are labelled checkboxes.',
    'Active filter count is surfaced via a Badge on the trigger.',
  ],
  usageExamples: [
    '<FilterPopover filters={defs} onApply={setFilters} searchable showSelectAll />',
    '<FilterPopover filters={defs} value={value} onApply={apply} persistKey="alerts" />',
  ],
  antiPatterns: [
    'Do not use for an always-visible sidebar (use FilterPanel).',
    'Do not put unrelated actions in the footer.',
  ],
  mountsSurface: 'portal',
  llmSafe: true,
  whenToUse: ['Table/list filter triggers', 'Compact filter menus'],
  whenNotToUse: ['Persistent filter sidebars (use FilterPanel)', 'A single search field (use Search)'],
});

export default filterPopoverMeta;
